<template>
  <div class="about-us">
    <div class="content content-padding">
      <div class="main-top-nav">
        <router-link to="/home"> <span class="desc">首页</span> </router-link>>
        <span>联系我们</span>
      </div>
      <div class="from">
        <div class="left-view">
          <div class="title">
            <h3>给我们留言</h3>
            <p>如果您有什么疑问，可以随时联系我们</p>
          </div>
          <div class="input">
            <input type="text" placeholder="您的名字" v-model="form.name" />
            <input type="text" placeholder="您的学号" v-model="form.code" />
            <input type="text" placeholder="您的邮箱" v-model="form.phone" />
            <input
              type="text"
              placeholder="希望邀请的嘉宾"
              v-model="form.jiabing"
            />
            <textarea
              name
              id
              cols="30"
              rows="10"
              placeholder="您的留言"
              v-model="form.content"
            ></textarea>
          </div>
          <div class="btn">
            <button class="btn-primary" @click="submitMsgDeliver()">
              提交
            </button>
          </div>
        </div>
        <div class="right-view">
          <div class="title">上海交通大学励志讲坛</div>
          <div class="desc">
            <p>联系人：{{ contactInfo.user }}</p>
            <p>手机：{{ contactInfo.phone }}</p>
            <p>邮箱：{{ contactInfo.email }}</p>
          </div>
          <!-- <div class="desc">
            <p>联系人：危笑东</p>
            <p>手机：13262774801</p>
          </div> -->
        </div>
      </div>
      <div id="sjtumap"></div>
    </div>
  </div>
</template>

<script>
import { Api } from "../api";
import { HttpClient } from "../util/http";

export default {
  data() {
    return {
      form: {
        name: "",
        phone: "",
        content: "",
      },
      contactInfo: {},
    };
  },
  created() {
    this.initState();
  },
  mounted() {
    new AMap.Map("sjtumap", {
      zoom: 15, //级别
      center: [121.436882, 31.025626], //中心点坐标
    });
  },
  methods: {
    initState() {
      HttpClient.get(Api.settingFetch).then((res) => {
        this.contactInfo = res.contactInfo;
      });
    },
    submitMsgDeliver() {
      HttpClient.put(Api.messageDeliver, this.form)
        .then((result) => {
          Object.keys(this.form).forEach((key) => {
            this.form[key] = "";
          });
          this.$message.success({
            offset: 200,
            message: "留言成功",
          });
        })
        .catch((err) => {
          if (err) {
            this.$message.error("留言失败，请稍后尝试");
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../theme.less";
.about-us {
  position: relative;
  .content {
    padding-bottom: 100px;
    .from {
      padding: 30px;
      background: #fff;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      input,
      textarea {
        background-color: #f5f7fb;
        border-radius: 4px;
        padding: 12px 28px;
        width: 70%;
        display: block;
        margin-bottom: 20px;
        &::-webkit-input-placeholder {
          color: #b4c2d3;
        }
      }
      textarea {
        resize: none;
      }
      .left-view {
        width: 50%;
        .title {
          position: relative;
          padding-left: 32px;
          text-align: left;
          &::after {
            content: " ";
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 12px;
            height: 50px;
            background-color: @primary-color;
          }
          h3 {
            color: #606266;
          }
          p {
            font-size: 12px;
            color: #b4c2d3;
          }
        }
        .btn {
          width: 70%;
          text-align: center;
        }
        .btn-primary {
          border-radius: 4px;
          padding: 10px 54px;
        }
      }
      .right-view {
        text-align: left;
        position: relative;
        width: 50%;
        &::after {
          content: " ";
          position: absolute;
          left: -35px;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 1px;
          height: 60%;
          background: #f0f2f6;
        }
        .title {
          width: 480px;
          color: @primary-color;
          font-size: 16px;
          margin-top: 20px;
          position: relative;
          margin-bottom: 20px;
          &::after {
            position: absolute;
            content: " ";
            display: block;
            width: 100px;
            height: 8px;
            bottom: -15px;
            background-color: @primary-color;
          }
        }
        .desc {
          margin-top: 40px;
          p {
            color: @text-color;
          }
        }
      }
    }
    #sjtumap {
      // background-image: url(http://www.yibaicdn.com/4f13ca40-814e-11e9-a0be-8359aed93c78.jpeg);
      // background-repeat: no-repeat;
      // background-size: cover;
      height: 358px;
      width: 100%;
    }
  }
}
@media screen and (max-device-width: 480px) {
  .about-us {
    .content {
      padding: 0 !important;
    }
  }
}
</style>
